import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { App, AllTopicsPage } from './App';
import { sections } from './data';
import ReactGA from 'react-ga4';

ReactGA.initialize('G-TRPYG59HLG');

const PageTracker = () => {
    const location = useLocation();

    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: location.pathname });
    }, [location]);

    return null;
};

const RoutesComponent = () => {
    return (
        <Router>
            <PageTracker />
            <Routes>
                <Route path="/" element={<App />} />
                {sections.map((section) =>
                    section.viewAllLink ? (
                        <Route key={section.id} path={section.viewAllLink} element={<AllTopicsPage section={section} />} />
                    ) : null
                )}
            </Routes>
        </Router>
    );
};

export default RoutesComponent;
